module.exports = __webpack_public_path__ + "img/andrew-pena-san-gabriele-canyon.021741f.jpg";